export default "__VITE_ASSET__CfEUy4ya__";